<template>
  <div class="" style="">
    <el-form id="contain" :model="userForm" :rules="rules" ref="userForm" label-width="120px" class="demo-ruleForm my  clearfix" style="padding:10px;background-color: #fff;min-width: 249px
    ">
      <div class="clearfix">
        <div class="fl">
          <div class="juetitle">角色信息：</div> 
          <el-form-item label="角色名称：" class="tinp" prop="role_name">
            <el-input v-model="userForm.role_name" placeholder="请输入角色名" suffix-icon="el-icon-edit" clearable></el-input>
          </el-form-item>
           <el-form-item label="角色备注：" class="tinp">
            <el-input v-model="userForm.role_memo" placeholder="请输入角色名" suffix-icon="el-icon-edit" clearable></el-input>
          </el-form-item>
        </div> 
        <div class="fl" style="padding-left:5%;margin-left:5%;border-left: 1px solid #ccc">
          <div class="juetitle">菜单列表：</div> 
              <el-tree :data="roleList" :default-checked-keys="indexlist" show-checkbox default-expand-all node-key="pk_menu" ref="tree" highlight-current :props="defaultProps">
              </el-tree>  
          </el-tree>
        </div>
      </div>
      <div class="clearfix">
        <el-button type="primary" style="margin-bottom: 10px" class="fr" size="small" @click="submitForm('userForm')">确认提交</el-button>
        <el-button size="small" type="warning" class="fr" style="margin-right: 20px" @click="returnManage">取消新增</el-button>
      </div>
    </el-form> 
    <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div>
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
</template>
<script>
import MessageModel from '../../components/MessageModel'
export default {
  data() { 
    var validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('角色名不能为空'));
      } else {
        callback();
      }
    };
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      step: 0,
      fullscreenLoading:true,
      userForm:{             
        role_code:'',
        role_name:'',
        role_memo:'',
        pk_menus:'',
      },
      keylists:'',
      roleList:[],
      indexlist:[],
      defaultProps: {
        children: 'children',
        label: 'menu_name'
      },
      rules: { 
        role_name: [
          { required: true, trigger: 'blur', validator: validateName }
        ]
      }
    }
  },
  mounted() {
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  methods: {
  	returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
          //  console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='adddrole'){
                    this.fullscreenLoading = true;
                    this.userForm.pk_menus=JSON.stringify(this.keylists)
                  //  console.log("打印选中菜单编码："+JSON.stringify(this.keylists));
                    this.$http.post(this.utilpath+'/insertRole',this.userForm,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                        if (res.data.status == '0') {
                          this.fullscreenLoading = false;
                          this.$message({
                            showClose: true,
                            message: '新增成功！',
                            type: 'success'
                          }); 
                          this.$router.push({path:'/ui/system/roleManage'});
                        } else if(res.data.status == '9'){
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                        } else {
                            this.fullscreenLoading = false;
                            this.modelFlag = true;
                            this.msgShow = true;
                            this.methodName = 'message';
                            this.msg = res.data.message;
                            this.butflag =false;
                            this.butmsg='知道了';
                        };
                      }, (err) => {
                            this.fullscreenLoading = false;
                            this.msgShow =false;
                            this.modelFlag = true;
                            this.methodName = 'message';
                            this.msg = '连接新增角色接口失败'+err;
                            this.butflag =false;
                            this.butmsg='知道了';
                      });
              }
      }else{
        this.fullscreenLoading = false;
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) { 
      this.modelFlag = false; 
       if (flag) {
       // console.log("---进来了！！！----" + this.methodName);
        if (this.methodName == 'message') {

        } 
      }
    },
    returnManage() {
      this.$router.push({ path: '/ui/system/roleManage' }); //跳转页面
    },
    init() { 
       this.selectMenuPk();
       this.selectMenu();
    },
    selectMenuPk(){
        this.$http.post(this.utilpath + '/selectAllMenuPK',{ emulateJSON: true,_timeout:600 }).then((res) => {
              if (res.data.status == '0') {
                  this.indexlist = res.data.resultList;
                 // console.log("打印所有菜单下标"+this.indexlist)
              } else if(res.data.status == '9'){
                  this.$router.push({path:'/ui/login',query:{msg:9}});
              } else {
                  this.modelFlag = true;
                  this.msgShow = true;
                  this.methodName = 'message';
                  this.msg = res.data.message;
                  this.butflag =false;
                  this.butmsg='知道了';
              };
        }, (err) => {
              this.modelFlag = true;
              this.msgShow =false;
              this.methodName = 'message';
              this.msg = '连接获取菜单接口失败'+err;
              this.butflag =false;
              this.butmsg='知道了';
        }); 
    },
    selectMenu(){
      var param ={
        is_virtual:'0',
      }
      this.$http.post(this.utilpath + '/selectMenu',param, { emulateJSON: true,_timeout:600 }).then((res) => {
        if (res.data.status == '0') {
            this.fullscreenLoading = false;
            this.roleList = res.data.resultList; 
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了';
        };
      }, (err) => {
            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow =false;
            this.methodName = 'message';
            this.msg = '连接获取菜单接口失败'+err;
            this.butflag =false;
            this.butmsg='知道了';
      });

    },
    toTop() {
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById("contain").scrollTop) / 8
      this.step += dis;
      document.getElementById("contain").scrollTop -= dis;
      var scroll = document.getElementById("contain").scrollTop;
      if (scroll > 0) {
       // console.log("回到顶部循环内" + document.getElementById("contain").scrollTop);
        var c = setTimeout(() => this.toTop(), 16);
      } else {
        clearTimeout(c);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        var keylist = this.$refs.tree.getCheckedKeys();
        if (valid) {
        //  console.log("+++++++++++++" + keylist.length);
          if (keylist.length < 1) {
            this.$message({
              showClose: true,
              message: '至少选择一个菜单',
              type: 'error'
            });
          } else {
            this.keylists=keylist;
            this.methodName = 'adddrole';
            this.msgShow =false;
            this.modelFlag = true;
            this.butflag = true;
            this.butmsg='确认';
            this.msg = '确定新增该角色？'
            
          }
        } else {
          this.$message({
            showClose: true,
            message: '填写信息不符合！',
            type: 'error'
          });
          this.toTop();
          return false;
        }
      });
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/AddRole.vue